import React from 'react';
import BaseComponent from './BaseComponent';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import logo from '../img/logo-menu.png';
import $ from 'jquery';

const ENV_CONFIGS = {
    development: {
        label: 'ENTORNO: DESARROLLO',
        ribbonBg: '#1d4ed8',
        bodyColor: 'rgba(37, 99, 235, 0.18)',
    },
    test: {
        label: 'ENTORNO: TEST',
        ribbonBg: '#b45309',
        bodyColor: 'rgba(180, 83, 9, 0.18)',
    },
};

class Menu extends BaseComponent {

    loadOnConstructor(){
    	    this.logout = this.logout.bind(this);
    	    this.logoutPrompt = this.logoutPrompt.bind(this);
    }

    componentDidMount(){
        const env = process.env.REACT_APP_ENV;
        const cfg = ENV_CONFIGS[env];
        if (cfg) {
            document.body.style.backgroundColor = cfg.bodyColor;
        }
    }

    componentWillUnmount(){
        document.body.style.backgroundColor = '';
    }

    showSubmenu(event){
        let actualSelection = null;
        Array.prototype.forEach.call(document.getElementsByClassName("submenu"), element => { 
            if (element.style.display === 'block')
                actualSelection = element.id;
            element.style.display="none";
        });
        let parentId = event.target.id.split("_");
        if(parentId.length <= 1) return;
        parentId = parentId[1];
        const element = document.getElementById('submenu_'+parentId);
        if(element.style.display === "none" && element.id !== actualSelection){
            element.style.display = "block";
        }else{
            element.style.display = "none";
        }
    }

    logoutPrompt(e){
        e.preventDefault();
		this.props.setModalContent({
			title: 'Confirme',
			body: ['¿Está seguro de que desea salir?'],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', callback: this.logout, close: true},
				{shown: 'Cancelar', close: true},
			]
		});
		$("#exampleModal").modal('toggle');
    }

    logout(){
	    localStorage.removeItem('token');
	    this.navigateTo('/login');
    }

    render() {

        const localUser = localStorage.getItem('user');
        const user = JSON.parse(localUser) || null;

	/////////////////////////////////////////////////////////////////////////////////////////////////
        const isAdmin = this.isSystemAdmin();
        const menuOptions = this.props.menu.options.map(option => {
            if (option.name === 'Facturación' && isAdmin) {
                return { ...option, sub: [...option.sub, { name: 'Verifactu', url: '/verifactu', sub: [] }] };
            }
            return option;
        });

        const responsiveOptions = menuOptions.map((option, i) => {
            	const hasSub = option.sub.length >0;
		return (
			<li key={'menu'+i} className={hasSub?'nav-item dropdown':'nav-item'}>
				<Link className={hasSub?'nav-link dropdown-toggle':'nav-link'}
                    onClick={(e) => { if(!option.url){e.preventDefault();return}}}
					id={"navbarDropdown"+i}
					role={hasSub?'button':undefined}
					data-toggle={hasSub?'dropdown':undefined}
					aria-haspopup={hasSub?'true':undefined}
					aria-expanded={hasSub?'false':undefined}
                    to={option.url || ''}>{option.name}</Link>
				{hasSub?
				<div className="dropdown-menu" aria-labelledby={"navbarDropdown"+i}>
					{option.sub.map((subop, j) => {
						return (
							<Link key={'dropdown'+i+'_'+j} className="dropdown-item" to={subop.url}>{subop.name}</Link>
						);
					})}
				</div>
				:''}
			</li>
		);
	});

        if(this.isSystemAdmin() && this.isMobileApp()){
            const environmentOptions = [
                {key: 'Entorno_local', name: 'Localhost', click: function(){window.ReactNativeWebView.postMessage(JSON.stringify({environment: 'localhost'}));}},
                {key: 'Entorno_desarrollo', name: 'Desarrollo', click: function(){window.ReactNativeWebView.postMessage(JSON.stringify({environment: 'desarrollo'}));}},
                {key: 'Entorno_test', name: 'Test', click: function(){window.ReactNativeWebView.postMessage(JSON.stringify({environment: 'test'}));}},
                {key: 'Entorno_prod', name: 'Prod', click: function(){window.ReactNativeWebView.postMessage(JSON.stringify({environment: 'prod'}));}}
            ]

            responsiveOptions.unshift(<li key={"MenuAdminVersion"} className='nav-item dropdown'>
                <Link className='nav-link dropdown-toggle' onClick={(e) => { e.preventDefault();return}}
					id={"navbarDropdown_Entornos"}
					role='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                    to=''>
                        Entorno
                </Link>
                <div className="dropdown-menu" aria-labelledby='navbarDropdown_Entornos'>
                    {environmentOptions.map(option => {
                        return <Link key={option.key} className="dropdown-item" to='' onClick={option.click}>
                                    {option.name}
                                </Link>
                    })}
				</div>
            </li>)
        }

        responsiveOptions.push(
        	<li className="nav-item" key='logout' onClick={this.logoutPrompt}><Link to={""} onClick={(e) => e.preventDefault()} className="nav-link">Salir</Link></li>
        );

        //Main menu structure
        const env = process.env.REACT_APP_ENV;
        const envCfg = ENV_CONFIGS[env];

        return (
          <React.Fragment>
            {envCfg && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
                    backgroundColor: envCfg.ribbonBg,
                    color: '#fff', textAlign: 'center',
                    fontSize: '11px', fontWeight: 700, letterSpacing: '3px',
                    padding: '5px 0', textTransform: 'uppercase',
                }}>
                    {envCfg.label}
                </div>
            )}
	  <nav className="navbar navbar-expand-lg navbar-light bg-light" style={envCfg ? {marginTop: '28px'} : undefined}>
  	    <a className="navbar-brand" href="dummie" onClick={(e) => e.preventDefault()}>
    	      <img alt="" src={logo} />
  	    </a>
  	    <button className="navbar-toggler" type="button" data-toggle="collapse" 
  	    	data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
  	    	aria-expanded="false" aria-label="Toggle navigation">
    	      <span className="navbar-toggler-icon"></span>
  	    </button>

  	    <div className="collapse navbar-collapse" id="navbarSupportedContent">
    	      <ul className="navbar-nav mr-auto">
      	        {responsiveOptions}
    	      </ul>
  	    </div>
	    <div className="row">
	      <div className="col-12 text-right">
		Usuario: {user?user.name+' '+user.lastname:'Sin usuario'}
	      </div>
	    </div>
	  </nav>
          </React.Fragment>
        )
    }

    liStyle = {
        float:"left",
        padding: "8px",
        textDecoration: "none",
        color: "white",
        cursor: "pointer",
    }

    ulStyle = {
        listStyleType: "none",
        padding:"0px",
        marginBottom:"0px"
    }

    labelOptionStyle = {
        cursor: "pointer",
	color: "white"
    }

    mainOptionStyle = {
	color:"white",
	textDecoration: "none"
    }

    submenuStyle = {
        margin: "0px",
        padding: "5px",
        display: "none",
        position: "absolute",
        border: "1px solid #CCC",
        background: "white"
    }

    suboptionStyle = {
        paddingBottom: "5px"
    }

    mainMenuStyle = {
        width: "100%",
        height: "60px",

    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu,
        username: state.username
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
